import { render, staticRenderFns } from "./RedirectDomainsList.vue?vue&type=template&id=53c128e0&scoped=true&"
import script from "./RedirectDomainsList.vue?vue&type=script&lang=js&"
export * from "./RedirectDomainsList.vue?vue&type=script&lang=js&"
import style0 from "./RedirectDomainsList.vue?vue&type=style&index=0&id=53c128e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c128e0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/source/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53c128e0')) {
      api.createRecord('53c128e0', component.options)
    } else {
      api.reload('53c128e0', component.options)
    }
    module.hot.accept("./RedirectDomainsList.vue?vue&type=template&id=53c128e0&scoped=true&", function () {
      api.rerender('53c128e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/redirect-domains/RedirectDomainsList.vue"
export default component.exports